export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/blackberry-bullet.54cdf8de.svg","height":12,"width":9};